import React, { useEffect, useState } from "react"
import {
  Row,
  Col,
  CardBody,
  Card,
  Alert,
  Container,
  Input,
  Label,
  FormFeedback,
  Modal,
  Button,
} from "reactstrap"

import Select from "react-select"

// Formik Validation
import * as Yup from "yup"
import { useFormik } from "formik"

import { Link, useHistory, useParams, useLocation } from "react-router-dom"

// import images
import logo from "assets/images/logo-large.png"

import "../../../assets/scss/custom/style.css"

import Autocomplete from "@material-ui/lab/Autocomplete"
import Box from "@material-ui/core/Box"
import { TextField } from "@material-ui/core"
import Snackbars from "../../../Utils/Snackbars"
import useRequestsWOAccessToken from "../../../Utils/useRequestsWOAccessToken"
import i18next from "i18next"

const colourStyles = {
  menuList: styles => ({
    ...styles,
    background: "#ffffff",
  }),
  option: (styles, { isFocused, isSelected, isDisabled }) => ({
    ...styles,
    background: isFocused
      ? "#036B41"
      : isSelected
        ? isSelected
          ? "#036B41"
          : "#000"
        : undefined,
    zIndex: 1,
    color: isFocused
      ? "#fff"
      : isSelected
        ? isSelected
          ? "#F7F7FA"
          : "#000"
        : undefined,
    ":active": {
      ...styles[":active"],
      backgroundColor: !isDisabled
        ? isSelected
          ? "#fff"
          : "#036B41"
        : undefined,
    },
  }),
  menu: base => ({
    ...base,
    zIndex: 100,
  }),
}

const Tax = props => {
  //meta title
  document.title = i18next.t("Register PG document title")
  const history = useHistory()
  const { getRequestWOAccessToken, postRequestWOAccessToken } =
    useRequestsWOAccessToken()
  const { referral_code } = useParams()
  const location = useLocation()

  const [AlertData, setAlertData] = React.useState({
    variant: "",
    message: "",
  })
  const resetAlertData = () => {
    setTimeout(() => {
      setAlertData(AlertData => ({
        ...AlertData,
        variant: "",
        message: "",
      }))
    }, 5000)
  }

  const [formData1, setFormData1] = React.useState({
    country: { label: "Spain", value: "Spain" },
    country_code: { id: 212, title: "ES +34", code: "ES", value: 34 },
  })
  const [CustomError1, setCustomError1] = React.useState({
    country: "",
    country_code: "",
  })
  const validation1 = useFormik({
    enableReinitialize: true,

    initialValues: {
      tax_id: "",
    },
    validationSchema: Yup.object({
      tax_id: Yup.string()
      .required(i18next.t("Register PG Tax Id is required"))
      .test(
        "spain-tax-validation",
        i18next.t("Invalid Spanish Tax ID format"),
        function (value) {
          if (formData1.country.value === "Spain") {
            if (!value) return false;

            const nifRegex = /^\d{8}[A-Za-z]$/;              // 12345678Z
            const nieRegex = /^[A-Za-z]\d{7}[A-Za-z]$/;      // X1234567L

            return nifRegex.test(value) || nieRegex.test(value);
          }

          return true; // Skip format validation if not Spain
        }
      ),
    }),
    onSubmit: async values => {
      try {
        setCustomError1({
          ...CustomError1,
          country: "",
        })

        if (formData1.country === null) {
          setCustomError1({
            ...CustomError1,
            country: i18next.t("Register PG Please select country"),
          })
        } else {
          let submit1 = document.getElementById("submit1")
          submit1.disabled = true
          submit1.textContent = i18next.t("Processing...")

          const additionalData = {}
          if (values.mailchimp == true) {
            additionalData.mailchimp = values.mailchimp
          }
          const jsonpar = JSON.stringify({
            u_id: UID,
            tax_id: values.tax_id,
            tax_residency: formData1.country.value,
          })
          const res = await postRequestWOAccessToken(
            "signup-tax-details",
            jsonpar,
          )
          if (res && res.code === 200) {
            let originalText = res.data

            history.push("/terms", {
              id: UID,
              email: Email,
              country_code: CountryCode,
              phone: Phone,
              code: 200,
              status: "success",
              message: res.message,
            })
          } else {
            setAlertData(AlertData => ({
              ...AlertData,
              variant: "error",
              message: res.message,
            }))
          }
          resetAlertData()

          submit1.disabled = false
          submit1.textContent = i18next.t("Continue")
        }
      } catch (error) {
        console.error("Error : ", error)
      }
    },
  })

  const [AllCountriesCustomData, setAllCountriesCustomData] = React.useState([])
  const [AllCountriesCustomData2, setAllCountriesCustomData2] = React.useState(
    [],
  )
  const handleLoadGetAllCountries = async phone_code => {
    const res = await getRequestWOAccessToken("get-all-countries")
    if (res && res.code === 200) {
      let originalText = res.data

      // Country dropdown (names)
      let countryOptions = originalText.map(element => ({
        label: element.country_name,
        value: element.country_name,
      }))

      setAllCountriesCustomData2([{ options: countryOptions }])

      // Country code dropdown (phone codes)
      let phoneOptions = originalText.map(element => ({
        id: element.id,
        title: element.country_code + " +" + element.phone_code,
        code: element.country_code,
        value: element.phone_code,
        country_name: element.country_name,
      }))

      setAllCountriesCustomData(phoneOptions)

      // ✅ Find default country using phone_code
      const matchedCountry = phoneOptions.find(
        el => String(el.value) === String(phone_code),
      )
      if (matchedCountry) {
        setFormData1({
          country: {
            label: matchedCountry.country_name,
            value: matchedCountry.country_name,
          },
          country_code: matchedCountry,
        })
      }
    } else {
      setAlertData(AlertData => ({
        ...AlertData,
        variant: "error",
        message: res.message,
      }))
    }
    resetAlertData()
  }
  const [PreferredLanguage, setPreferredLanguage] = React.useState("eng")
  const onChangePreferredLanguage = e => {
    i18next.changeLanguage(e.target.value)
    setPreferredLanguage(e.target.value)
    localStorage.setItem("I18N_LANGUAGE", e.target.value)
  }

  const handleLoadGetSignupStatus = async u_id => {
    const jsonpar = JSON.stringify({
      u_id: u_id,
    })

    const res = await postRequestWOAccessToken("signup-status", jsonpar)
    if (res && res.code === 200) {
      let originalText = res.data
      if (originalText.is_email_verified == 0) {
        history.push("/email-verification", {
          id: u_id,
          email: originalText.email,
          collaborator_referral_code:
            originalText.signup_temp_collaborator_code,
          referral_code: originalText.signup_temp_referral_code,
        })
      } else if (
        originalText.phone == "" ||
        originalText.phone == null ||
        originalText.phone == undefined
      ) {
        history.push("/add-phone", {
          id: u_id,
          email: originalText.email,
          collaborator_referral_code:
            originalText.signup_temp_collaborator_code,
          referral_code: originalText.signup_temp_referral_code,
        })
      } else if (originalText.is_phone_verified == 0) {
        history.push("/phone-verification", {
          id: u_id,
          email: originalText.email,
          country_code: originalText.country_code,
          phone: originalText.phone,
          collaborator_referral_code:
            originalText.signup_temp_collaborator_code,
          referral_code: originalText.signup_temp_referral_code,
        })
      } else if (
        originalText.first_name == null ||
        originalText.first_name == "" ||
        originalText.last_name == null ||
        originalText.last_name == ""
      ) {
        history.push("/personal-details", {
          id: u_id,
          email: originalText.email,
          country_code: originalText.country_code,
          phone: originalText.phone,
          collaborator_referral_code:
            originalText.signup_temp_collaborator_code,
          referral_code: originalText.signup_temp_referral_code,
        })
      } else if (originalText.address == null || originalText.address == "") {
        history.push("/address", {
          id: u_id,
          email: originalText.email,
          country_code: originalText.country_code,
          phone: originalText.phone,
          country: originalText.country,
          collaborator_referral_code:
            originalText.signup_temp_collaborator_code,
          referral_code: originalText.signup_temp_referral_code,
        })
      } else if (originalText.tax_id == null || originalText.tax_id == "") {
        return
      } else if (originalText.accept_terms == "false") {
        history.push("/terms", {
          id: u_id,
          email: originalText.email,
          country_code: originalText.country_code,
          phone: originalText.phone,
          collaborator_referral_code:
            originalText.signup_temp_collaborator_code,
          referral_code: originalText.signup_temp_referral_code,
        })
      } else {
        history.push("/login")
      }
    } else {
      setAlertData(AlertData => ({
        ...AlertData,
        variant: "error",
        message: res.message,
      }))
    }
  }

  const [UID, setUID] = React.useState(0)
  const [Email, setEmail] = React.useState("")
  const [CountryCode, SetCountryCode] = React.useState("")
  const [Phone, setPhone] = React.useState("")
  const [StateCountry, SetStateCountry] = React.useState("")
  React.useEffect(() => {
    const language = localStorage.getItem("I18N_LANGUAGE")
    if (!language) setPreferredLanguage("sp")
    else setPreferredLanguage(language)

    if (referral_code) {
      validation1.setValues({
        ...validation1.values,
        referral_code: referral_code,
      })
    }

    if (
      typeof location.state !== "undefined"
    ) {
      handleLoadGetSignupStatus(location.state.id)
      handleLoadGetAllCountries(location.state.country_code)
      setUID(location.state.id)
      setEmail(location.state.email)
      SetCountryCode(location.state.country_code)
      setPhone(location.state.phone)
      SetStateCountry(location.state.country)
      if(location.state.message){
        setAlertData(AlertData => ({
          ...AlertData,
          variant: location.state.status,
          message: location.state.message,
        }))
        resetAlertData()
      }
    }
  }, [])

  return (
    <React.Fragment>
      {AlertData.message !== "" ? (
        <Snackbars variant={AlertData.variant} message={AlertData.message} />
      ) : (
        ""
      )}
      <div className="p-0 container-fluid">
        {/* <select
          className="form-select top-right-lang"
          name="preferred_language"
          value={PreferredLanguage}
          onChange={e => onChangePreferredLanguage(e)}
        >
          <option value={"eng"}>English</option>
          <option value={"sp"}>Spanish</option>
        </select> */}
        <Row className="g-0">
          <Col className="LeftImg">
            <div className="auth-full-page-content p-3 bg-white">
              <div className="w-100">
                <div className="d-flex flex-column h-100">
                  <div className="mb-4 mb-md-5">
                    <Link to="/" className="auth-logo-light">
                      <div className="mb-1">
                        <span className="">
                          {" "}
                          <img src={logo} alt="" height="60" />{" "}
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="my-auto">
                    <div className="text-primary p-4">
                      <h2 className="text-black mb-3">
                        {i18next.t("Tax Residency")}
                      </h2>
                      <p className="text-black" style={{ fontSize: '17px' }}>
                        {i18next.t("We need this information to comply with regulatory requirements")}
                      </p>
                    </div>
                    <div className="mt-4">
                      <div className="p-2">
                        <div className="form-horizontal">
                          <div className="row">
                            <Col md={12}>
                              <div className="mb-3 Register-Select2">
                                <Label className="form-label">
                                  {i18next.t("Select Tax Residency")} :
                                </Label>
                                <Select
                                  styles={colourStyles}
                                  value={formData1.country}
                                  onChange={e =>
                                    setFormData1({ ...formData1, country: e })
                                  }
                                  options={AllCountriesCustomData2}
                                  classNamePrefix="select2-selection"
                                />
                                {CustomError1.country !== "" ? (
                                  <FormFeedback
                                    type="invalid"
                                    style={{ display: "block" }}
                                  >
                                    {CustomError1.country}
                                  </FormFeedback>
                                ) : null}
                                <small className="text-muted d-block mt-1">
                                  {i18next.t("withholding")}
                                </small>
                              </div>
                            </Col>
                          </div>
                          <div className="row">
                            <Col md={12}>
                              <div className="mb-3">
                                <Label className="form-label">
                                  {i18next.t("Enter Tax ID")} :
                                </Label>
                                <Input
                                  name="tax_id"
                                  type="text"
                                  placeholder={i18next.t("Enter Tax ID1")}
                                  onChange={validation1.handleChange}
                                  onBlur={validation1.handleBlur}
                                  value={validation1.values.tax_id || ""}
                                  invalid={
                                    validation1.touched.tax_id &&
                                    validation1.errors.tax_id
                                      ? true
                                      : false
                                  }
                                />
                                {validation1.touched.tax_id &&
                                validation1.errors.tax_id ? (
                                  <FormFeedback type="invalid">
                                    {validation1.errors.tax_id}
                                  </FormFeedback>
                                ) : null}
                              </div>
                            </Col>
                          </div>

                          <div className="mt-4 d-grid">
                            <Button
                              id="submit1"
                              onClick={e => {
                                e.preventDefault()
                                validation1.handleSubmit()
                                return false
                              }}
                              data-toggle="modal"
                              data-target="#myModal"
                              className="btn btn-primary btn-block"
                            >
                              {" "}
                              {i18next.t("Continue")}{" "}
                            </Button>
                          </div>
                        </div>
                        <div className="mt-3 text-center">
                          <p className="mb-0"></p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mt-4 mt-md-5 text-center">
                    <p className="footer-text-color">
                      {" "}
                      © {new Date().getFullYear()} Tokenized Green.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Col>
          <Col className="rightImg">
            <div className="bgLogin"></div>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  )
}

export default Tax
